import { Paper, Stack, Typography } from "@mui/material";

import InlineCode from "@/common/components/Code/InlineCode";

// https://mui.com/material-ui/react-paper

export function DevPaper() {
  return (
    <Stack spacing={2}>
      <Typography component='div' variant='h2'>
        Paper
      </Typography>

      <Stack spacing={2}>
        <Typography component='div' variant='h5'>
          <InlineCode>MUI Paper</InlineCode>
        </Typography>

        <Stack direction='column' spacing={2}>
          <Typography component='div' variant='h6'>
            Variant
          </Typography>
          <Stack direction='row' spacing={2} alignItems='center'>
            <Stack spacing={2} sx={{ p: 4, backgroundColor: (th) => th.palette.background.paper }}>
              <Paper sx={{ p: 2 }}>
                Default paper. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque
                voluptate repellendus similique soluta laboriosam sequi harum doloremque commodi
                facilis cupiditate fugit perferendis doloribus quisquam nulla rem, in ut est hic.
              </Paper>

              <Paper sx={{ p: 2 }} variant='elevation'>
                Elevation paper. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque
                voluptate repellendus similique soluta laboriosam sequi harum doloremque commodi
                facilis cupiditate fugit perferendis doloribus quisquam nulla rem, in ut est hic.
              </Paper>

              <Paper sx={{ p: 2 }} variant='outlined'>
                Outline paper. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque
                voluptate repellendus similique soluta laboriosam sequi harum doloremque commodi
                facilis cupiditate fugit perferendis doloribus quisquam nulla rem, in ut est hic.
              </Paper>

              <Paper sx={{ p: 2 }} variant='contained'>
                Contained paper. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque
                voluptate repellendus similique soluta laboriosam sequi harum doloremque commodi
                facilis cupiditate fugit perferendis doloribus quisquam nulla rem, in ut est hic.
              </Paper>
            </Stack>
          </Stack>
        </Stack>

        <Stack direction='column' spacing={2}>
          <Typography component='div' variant='h6'>
            Elevation
          </Typography>
          <Stack
            sx={{ p: 4, backgroundColor: (th) => th.palette.background.paper, flexWrap: "wrap" }}
            direction='row'
            gap={2}
          >
            {Array.from({ length: 25 }).map((_, index) => (
              <Paper key={index} sx={{ p: 2, width: 200 }} elevation={index}>
                elevation={index}.
              </Paper>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
